'use client';

import { SuperTokensProvider } from './SuperTokensProvider';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return (
    <SuperTokensProvider>
      {children}
    </SuperTokensProvider>
  );
}
